import type { QueryClient } from '@tanstack/react-query';

type GetOrFetchQueryParams<T> = {
  key: unknown[];
  fetcher: () => Promise<T>;
  queryClient: QueryClient;
};

const getOrFetchQuery = async <T>({
  key,
  fetcher,
  queryClient,
}: GetOrFetchQueryParams<T>): Promise<T> => {
  const cached = queryClient.getQueryData<T>(key);

  if (cached !== undefined && cached !== null) {
    return cached;
  }

  const fetched = await fetcher();
  queryClient.setQueryData(key, fetched);
  return fetched;
};

export default getOrFetchQuery;
